export function useCountdown(targetDate: string | Date) {
	const countdown = reactive({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0
	})

	let interval: NodeJS.Timeout

	const calculateTimeLeft = () => {
		const now = new Date().getTime()
		const distance = new Date(targetDate).getTime() - now

		if (distance < 0) {
			clearInterval(interval)
			return
		}

		countdown.days = Math.floor(distance / (1000 * 60 * 60 * 24))
		countdown.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
		countdown.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
		countdown.seconds = Math.floor((distance % (1000 * 60)) / 1000)
	}

	watch(
		() => targetDate,
		() => {
			if (interval) {
				clearInterval(interval)
			}
			calculateTimeLeft()
			interval = setInterval(calculateTimeLeft, 1000)
		},
		{ immediate: true }
	)

	onUnmounted(() => {
		clearInterval(interval)
	})

	return countdown
}
